import { createSelector } from 'reselect';
import { KEY, ConfigurationState } from './types';
import { GlobalState } from 'store/types';

const getConfigurationState = (state: GlobalState) => state[KEY] as ConfigurationState;

const selectLoading = createSelector(
  getConfigurationState,
  config => config.loading
);

const selectError = createSelector(
  getConfigurationState,
  config => config.error
);

const selectConfiguration = createSelector(
  getConfigurationState,
  config => config.configuration
);

export const selectors = {
  selectLoading,
  selectError,
  selectConfiguration
};
